export default "__VITE_ASSET__Jx1WzWTC__"